import dayjs from "dayjs";
import { DiscountTypes, IssueClosedStatusGroup } from "./constants";

export const textTranslate = (language) => (item = { en: '', el: '' }) => {
	return item[language]
}

export const roundToDecimal = (number, decimalPlaces) => {
	const factor = Math.pow(10, decimalPlaces);
	return Math.round(number * factor) / factor;
}

export const numberPercentage = (number, percentage) => {
	return parseFloat(roundToDecimal((number * percentage / 100), 2).toFixed(2))
}

export const applyPercentage = (number: number, percentage: number, minusPercentage: boolean = false) => {
	if (minusPercentage) {
		return parseFloat((number - numberPercentage(number, percentage)).toFixed(2))
	}
	return parseFloat((number + numberPercentage(number, percentage)).toFixed(2))
}

export const itemValue = (quantity = 0, price = 0) => (quantity * price)

export const calcItemTotalApplyingCharge = (quantity = 0, price = 0, pctCharge = 0) => {
	const value = itemValue(quantity, price)
	return applyPercentage(value, pctCharge)
}

export const calcItemsTotal = (items) => {
	return items?.reduce((sum, item) => {
		return sum + calcItemTotalApplyingCharge(item.Qty, item.ItemPrice, item.PCTCharge)
	}, 0)
}

export const chargeValueOnTotalItemValue = (pctCharge, items) => {
	const totalItemValue = calcItemsTotal(items)
	return parseFloat(roundToDecimal((totalItemValue * pctCharge / 100), 2).toFixed(2))
}

export const calcItemsTotalWithCharges = (items, charges) => {
	const itemsTotal = calcItemsTotal(items)
	const chargesTotal = charges?.reduce((sum, charge) => {
		return sum + chargeValueOnTotalItemValue(charge.PCTCharge, items)
	}, 0)
	return chargesTotal + itemsTotal
}

export const calcTotalWithMarkup = (items, charges, markup) => {
	const itemsTotalWithCharges = calcItemsTotalWithCharges(items, charges)
	return applyPercentage(itemsTotalWithCharges, markup)
}

export const calcTotalWithDiscount = (items, charges, markup, {discount = 0, discountType = DiscountTypes.Percentage}) => {
	const totalWithMarkup = calcTotalWithMarkup(items, charges, markup)
	return discountType === DiscountTypes.Percentage ? applyPercentage(totalWithMarkup, discount, true) : (totalWithMarkup - discount)
}

export const isUUID = (str) => {
	return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(str);
}

export const issueIsClosed = (statusId) => (IssueClosedStatusGroup.includes(Number(statusId)))

export const mapDateRange = (range = []) => {
	if (range && range.length > 0) {
		if (range[0] && range[1] && range[0]?.isValid() && range[1]?.isValid()) {
			return [dayjs(range[0]).format('YYYY-MM-DD'), dayjs(range[1]).format('YYYY-MM-DD')]
		} else if (range[0] && range[0]?.isValid() && (!range[1] || !range[1]?.isValid())) {
			return [dayjs(range[0]).format('YYYY-MM-DD'), dayjs(range[0]).format('YYYY-MM-DD')]
		} else if (range[1] && range[1]?.isValid() && (!range[0] || !range[0]?.isValid())) {
			return [dayjs(range[1]).format('YYYY-MM-DD'), dayjs(range[1]).format('YYYY-MM-DD')]
		}
	}
	return [null, null]
}